var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6765 20.7119C26.0759 20.7122 26.3999 21.0361 26.4001 21.4355C26.4001 21.8352 26.0761 22.1599 25.6765 22.1602H4.92358C4.52391 22.16 4.19995 21.8353 4.19995 21.4355C4.20021 21.0361 4.52407 20.7121 4.92358 20.7119H25.6765ZM25.6765 13.9561C26.0761 13.9563 26.4001 14.28 26.4001 14.6797C26.4001 15.0793 26.0761 15.4031 25.6765 15.4033H4.92358C4.52392 15.4032 4.19997 15.0794 4.19995 14.6797C4.19995 14.28 4.52391 13.9562 4.92358 13.9561H25.6765ZM25.6765 7.19922C26.076 7.19948 26.4 7.52333 26.4001 7.92285C26.4001 8.3225 26.0761 8.6472 25.6765 8.64746H4.92358C4.52391 8.64731 4.19995 8.32256 4.19995 7.92285C4.2001 7.52327 4.524 7.19937 4.92358 7.19922H25.6765Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBurger);
export default __webpack_public_path__ + "static/media/action-burger.e00a67d3086e13c9d715677897b2d349.svg";
export { ForwardRef as ReactComponent };